import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import FreeDayPopup1 from '../../asset/FreeDayPopup.webp'
import FreeDayPopup2 from '../../asset/FreeDayPopup2.webp'
import close from '../../asset/CrossButton.png'

const FreeDayPopup = ({ isOpen, onClose }) => {
    const navigate = useNavigate();
    const location = useLocation();
    
    if (!isOpen) return null;

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const handleBookNow = () => {
        navigate('/free-day-pass');
        onClose();
    };

    return (
        <div style={styles.overlay} onClick={handleOverlayClick}>
            <div style={styles.popup}>
                <button style={styles.closeButton} onClick={onClose}><img className='w-[20px]' src={close} /></button>
                <div className='flex flex-col items-center'>
                    <img style={{borderRadius:'15px 15px'}} className='h-auto sm:h-[60vh]' src={location.pathname === '/affordable-coworking-space' ? FreeDayPopup1 : FreeDayPopup2} alt='' />
                    <button
                        onClick={handleBookNow}
                        style={{ background: '#D41F30', marginBottom:'25px'}}
                        className='text-[12px] mt-4 sm:text-[18px] font-normal rounded-[30px] px-3 sm:px-5 py-1.5 sm:py-2 text-white transition-colors'>
                        {location.pathname === '/affordable-coworking-space' ? 'Book My Free Trial' : 'Claim Free Day'}
                    </button>
                </div>
            </div>
        </div>
    );
};

const styles = {
    overlay: {
        position: 'fixed',
        top: 0, left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
    },
    popup: {
        backgroundColor: 'white',
        borderRadius: '15px',
        position: 'relative',
        minWidth: '300px',
        maxWidth: '90%'
    },
    closeButton: {
        position: 'absolute',
        top: '10px',
        right: '10px',
        border: 'none',
        background: 'transparent',
        fontSize: '1.5rem',
        cursor: 'pointer',
        filter: 'brightness(0.3)'
    }
};

export default FreeDayPopup;
